import { ActionTree } from 'vuex';
import { EAttachmentsAction, EAttachmentsMutation, IAttachmentState } from './attachments.types';
import { getDefaultState } from './attachments.constants';
import { ISaveAttachmentDTO } from '@/api/attachments/dtos/save-attachment-dto';
import { AttachmentService } from '@/api/attachments/services/attachment.service';
import { RootState } from '@/store/store';

export const actions: ActionTree<IAttachmentState, RootState> = {
  async [EAttachmentsAction.SaveRecipientAttachment](
    { dispatch, commit },
    payload: ISaveAttachmentDTO
  ) {
    commit(EAttachmentsMutation.SetLoading, true);
    commit(EAttachmentsMutation.SetLoaded, false);
    try {
      await AttachmentService.save(payload);
      dispatch(EAttachmentsAction.SaveRecipientAttachmentSuccess);
    } catch (e) {
      dispatch(EAttachmentsAction.SaveRecipientAttachmentFailed);
    }
  },
  [EAttachmentsAction.SaveRecipientAttachmentSuccess]({ commit }) {
    commit(EAttachmentsMutation.SetLoaded, true);
    commit(EAttachmentsMutation.SetLoading, false);
  },
  [EAttachmentsAction.SaveRecipientAttachmentFailed]({ commit }) {
    commit(EAttachmentsMutation.SetLoaded, false);
    commit(EAttachmentsMutation.SetLoading, false);
  },
  async [EAttachmentsAction.SaveRestrictedAccessAttachment](
    { dispatch, commit },
    { payload, recipientIds }: { payload: ISaveAttachmentDTO; recipientIds: string[] }
  ) {
    commit(EAttachmentsMutation.SetLoading, true);
    commit(EAttachmentsMutation.SetLoaded, false);
    try {
      const attachmentId: string = await AttachmentService.save(payload);
      await AttachmentService.setRestrictAccessLegacy(
        payload.documentId,
        attachmentId,
        recipientIds
      );
      dispatch(EAttachmentsAction.SaveRecipientAttachmentSuccess);
    } catch (e) {
      dispatch(EAttachmentsAction.SaveRecipientAttachmentFailed);
    }
  },
  [EAttachmentsAction.Reset]({ commit }) {
    commit(EAttachmentsMutation.SetState, getDefaultState());
  },
};
